



import {Component, Vue} from 'vue-property-decorator'
import {Action, Mutation} from 'vuex-class'


@Component({})
export default class Task extends Vue {
  @Action('getTask') public getTask: any
  @Mutation('setLoader') public setLoader!: any

  public created() {
    this.setLoader(true)
    this.getTask(this.$route.params.id)
      .then(() => this.setLoader(false))
  }
}
